import React from 'react';
import {Box, IconButton, Paper, TextField,} from '@mui/material';
import {ArrowForward} from "@mui/icons-material";
import ChatStore from "../ChatStore.ts";
import {observer} from "mobx-react-lite";
import {useChatContext} from "../context/ChatContext.tsx";

type Props = {
    inputRef?: React.Ref<any>
}
export const ChatUserInput: React.FC<Props> = observer(({inputRef}) => {
    const {
        sendMessage,
        isRestoringSession,
        isWaiting,
    } = useChatContext();
    const inputValue = ChatStore.userInputValue;

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const v = inputValue.trim();
        if (v && !isWaiting) {
            sendMessage(v);
            ChatStore.setUserInputValue('');
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) handleSubmit(e)
    }

    const disabled = isRestoringSession || isWaiting;
    return <Paper
        elevation={0}
        className="input-area"
    >
        <Box
            component="form"
            onSubmit={handleSubmit}
            className="input-form"
        >
            <TextField
                inputRef={inputRef}
                fullWidth
                multiline
                maxRows={6}
                value={inputValue}
                onChange={(e) => ChatStore.setUserInputValue(e.target.value)}
                onKeyDown={handleKeyPress}
                placeholder={'Ask anything about your spend \u2026'}
                disabled={disabled}
                className="input-field"
            />
            <IconButton
                type="submit"
                disabled={!inputValue.trim() || disabled}
                className="submit-button"
            >
                <ArrowForward/>
            </IconButton>
        </Box>
    </Paper>
})